import { useVendor } from "context/vendor/vendor.provider";
import Image from "next/image";

export default function ImageVendorLogo() {
  const { vendor } = useVendor();

  if (vendor?.logo) {
    return (
      <div className="group relative mx-auto flex w-full max-w-[280px] justify-center">
        {/* Background glow effect */}
        <div className="absolute inset-0 scale-105 rounded-2xl bg-gradient-to-r from-blue-600/25 to-purple-600/25 opacity-0 blur-xl transition-opacity duration-500 group-hover:opacity-100"></div>

        {/* Logo container with enhanced styling */}
        <div className="hover:shadow-3xl relative rounded-2xl border border-gray-200 bg-white p-6 shadow-2xl backdrop-blur-sm transition-all duration-700 animate-in fade-in-50 slide-in-from-top-4 dark:border-gray-700 dark:bg-gray-800">
          {/* Subtle gradient overlay */}
          <div className="pointer-events-none absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-50/25 to-purple-50/25 dark:from-blue-900/10 dark:to-purple-900/10"></div>

          <Image
            src={vendor?.logo}
            width={200}
            height={120}
            priority
            sizes="(max-width: 768px) 100vw, 280px"
            alt={`${vendor?.name || "Vendor"} logo`}
            className="relative z-10 h-auto max-h-[120px] w-full object-contain transition-transform duration-300 group-hover:scale-105"
          />
        </div>
      </div>
    );
  }

  return null;
}
